
import {
    GET_DELIVERY_CONFIGURATION,
    GET_DELIVERY_CONFIGURATION_SUCCESS,
    GET_DELIVERY_CONFIGURATION_FAIL,
    SET_DELIVERY_CONFIGURATION,
    SET_DELIVERY_CONFIGURATION_SUCCESS,
    SET_DELIVERY_CONFIGURATION_FAIL,
    DELETE_DELIVERY_CONFIGURATION,
    DELETE_DELIVERY_CONFIGURATION_SUCCESS,
    DELETE_DELIVERY_CONFIGURATION_FAIL,
} from "./actionTypes";

// Delivery Configuration
export const getDeliveryConfiguration = () => ({
    type: GET_DELIVERY_CONFIGURATION,
});
export const getDeliveryConfigurationSuccess = deliveryConfiguration => ({
    type: GET_DELIVERY_CONFIGURATION_SUCCESS,
    payload: deliveryConfiguration,
});
export const getDeliveryConfigurationFail = error => ({
    type: GET_DELIVERY_CONFIGURATION_FAIL,
    payload: error,
});
// Add Delivery Configuration
export const setDeliveryConfiguration = data => ({
    type: SET_DELIVERY_CONFIGURATION,
    payload: data,
});
export const setDeliveryConfigurationSuccess = data => ({
    type: SET_DELIVERY_CONFIGURATION_SUCCESS,
    payload: data,
});
export const setDeliveryConfigurationFail = error => ({
    type: SET_DELIVERY_CONFIGURATION_FAIL,
    payload: error,
});
// Delete Delivery Configuration
export const deleteDeliveryConfiguration = data => ({
    type: DELETE_DELIVERY_CONFIGURATION,
    payload: data,
});
export const deleteDeliveryConfigurationSuccess = data => ({
    type: DELETE_DELIVERY_CONFIGURATION_SUCCESS,
    payload: data,
});
export const deleteDeliveryConfigurationFail = error => ({
    type: DELETE_DELIVERY_CONFIGURATION_FAIL,
    payload: error,
});
// hide notification
export const hideNotification = () => ({
    type: "HIDE_NOTIFICATION",
});